<kp-dashes
  class="quest-dashes"
  [isTrendingDown]="true"
  *ngIf="isDiamondCard && index % 2 !== 0 && !isMilestone"></kp-dashes>
<kp-dashes
  class="quest-dashes-milestone-odd"
  [isTrendingDown]="true"
  *ngIf="isMilestone && milestoneIndex % 2 === 1"></kp-dashes>
<button
  class="diamond"
  *ngIf="!milestoneDiamondIndicator"
  [ngClass]="{
    'selected': isSelected,
    'diamondCard': isDiamondCard,
    'milestoneCard': isMilestone,
    'appear-disabled': appearDisabled && !isSelected
  }"
  [disabled]="isDisabled && !isSelected">
  <span class="diamond-text">{{ text }}</span>
  <ng-container class="order" *ngIf="isDiamondCard">
    <div *ngIf="!isMilestone && !isSelected" [ngClass]="{ uncompletedCircle: !isMilestone && !isSelected }">
      {{ order }}
    </div>
    <svg-icon
      *ngIf="isSelected && !isMilestone"
      class="completedCircle"
      src="/assets/icons/checkmark-filled-circle.svg"></svg-icon>
    <svg-icon
      *ngIf="isSelected && isMilestone"
      class="completedMilestoneCircle"
      src="/assets/icons/checkmark-filled-circle.svg"></svg-icon>
    <kp-diamond
      class="uncompleted-milestone-diamond"
      [milestoneDiamondIndicator]="true"
      *ngIf="isMilestone && !isSelected"></kp-diamond>
  </ng-container>
</button>
<kp-dashes class="quest-dashes-milestone-even" *ngIf="isMilestone && milestoneIndex % 2 === 0"></kp-dashes>
<kp-dashes class="quest-dashes" *ngIf="isDiamondCard && index > 0 && index % 2 === 0 && !isMilestone"></kp-dashes>
